import { useSuspenseQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "@api/queryKeys";
import { getPressIdFromURL } from "@utils/getStateFromURL";

import { dealTypeCategoryApis } from "./dealTypeCategory.service";

export const useDealTypeCategoryQuery = (
  draftArticleId = Number(getPressIdFromURL()),
) => {
  return useSuspenseQuery({
    queryKey: [QUERY_KEYS.dealTypeCategory, draftArticleId],
    queryFn: () => dealTypeCategoryApis.get(draftArticleId),
    select: ({ data }) => data.dealTypeCategory,
    gcTime: 0,
    staleTime: 0,
  });
};
